// extracted by mini-css-extract-plugin
export default {"placeholder":"MatchLoad_placeholder__5KMPH","placeholdertiny":"MatchLoad_placeholdertiny__9ItDJ","fadein":"MatchLoad_fadein__yl5ue"};